import React, { useState } from "react";
import DetailsCard from './detailsCard';

const Details = () => {
  
  const [active, setActive] = useState(true);

   const toggle = (type) => {
     if(active && type === "cash"){
       setActive(false);
     }else if(!active && type === "atm"){
       setActive(true);
     }
   }
  return (
    <div className="col-lg-6 col-md-12 col-md-justify-content-center d-flex">
      <div className="row w-100 px-4 py-4">
        <div className="col-lg-12 col-md-12">
          <p className="h4heading font-weight-bold" style={{ padding: "0" }}>Pateint Details</p>
          <div className="form__group">
            <p className="h2desc font-weight-bold">This in-clinic appointment is for</p>
            <span>
              <div className="form__radio-group" style={{ width: "30%" }}>
                <input type="radio" className="form__radio-input" id="small" name="size" />
                <label htmlFor="small" className="form__radio-label">
                  <span className="form__radio-botton"></span>
                  <span>User</span> </label>
              </div>
              
              <div className="form__radio-group " style={{ width: "70%" }}>
                <input type="radio" className="form__radio-input" id="large" name="size" />
                <label htmlFor="large" className="form__radio-label">
                  <span className="form__radio-botton"></span>
                  <span>Someone Else</span> </label>
              </div>
            </span>
          </div>


          <p className="h2desc font-weight-bold">Please Provide Following information about user</p>

          <span className="h3desc">Full Name <sup style={{ color: "red", fontSize: "12px" }}>*</sup>:</span>
          <div className="form_input">
            <input className="form-control py-2 h-auto" placeholder="John Doe" type="text" id="name" required />
            <label className="ml-3" htmlFor="name">
              Full Name </label>
          </div>
          <br />

          <span className="h3desc">Mobile Number<sup style={{ color: "red", fontSize: "12px" }}>*</sup>:</span>
          <div className="form_input">
            <input className="form-control py-2 h-auto" placeholder="Number" type="number" id="mobile" required />
            <label className="ml-3" htmlFor="mobile">
              Mobile </label>
          </div>
          <br />

          <span className="h3desc">Your Email <sup style={{ color: "red", fontSize: "12px" }}>*</sup>:</span>
          <div className="form_input">
            <input className="form-control py-2 h-auto" placeholder="Enter Your Email Address" type="email" id="email" required />
            <label className="ml-3" htmlFor="email">
              Email </label>
          </div>

          <div className="form-check form-check-inline py-4">

            <label className="form-check-label chk-container" htmlFor="chk">
            <input className="form-check-input" type="checkbox" id="chk" value="option1" />
            <span className="chk-checkmark"></span>
            Chek updates on Whatsapp Number {" "} +880 123 1456
            </label>
          </div>


          <p className="h2desc font-weight-bold">Choose a payment option to book appointment</p>

          <div className="row">
            <div className="col-lg-6 col-md-12">
              <DetailsCard active={active ? "active" : ""} atm="atm" click={()=> toggle('atm')} pay="Pay Online" amount="$75" discount="$100" detail="Get instant 10% off on online payment" />
            </div>
            <div className="col-lg-6 col-md-12">
              <DetailsCard active={active ? "" : "active"} cash="cash" click={()=> toggle('cash')} pay="Pay Cash" amount="$100" discount="" detail="Pat later at the clinic" />
            </div>

          </div>
        </div>
        <br />
        <button className="w-100 w-md-50 mx-3 mt-4 mb-1 active tableButton">CONFIRM</button>
        <span className="h4desc w-100 text-center">update will send to +880 123 4567</span>
      </div>
    </div>


  );
};

export default Details;

